import { render, staticRenderFns } from "./SingleNumberA.vue?vue&type=template&id=0c558ebe&"
import script from "./SingleNumberA.vue?vue&type=script&lang=js&"
export * from "./SingleNumberA.vue?vue&type=script&lang=js&"
import style0 from "./SingleNumberA.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports